import { Component, Input } from '@angular/core';
import { Filter } from '../models/filter-models';
import { FormsModule } from '@angular/forms';
import { FilterService } from '../services/filter.service';
import { BaseComponent } from '../common/base.component';

@Component({
  selector: 'app-free-rules-tab',
  templateUrl: './free-rules-tab.component.html',
  styleUrl: './free-rules-tab.component.scss',
  imports: [FormsModule]
})
export class FreeRulesTabComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;

  constructor(private filterService: FilterService) {
    super();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
